import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { FileText, Download, FolderOpen } from 'lucide-react';
import { downloadSupport, formatTaille } from '../../components/ModuleSupportsSection';

export const SupportsTab = ({ data = [], lastSeen = null }) => {
  if (data.length === 0) {
    return (
      <Card className="border-0 shadow-sm">
        <CardContent className="py-12 text-center" data-testid="supports-empty">
          <FolderOpen className="w-12 h-12 text-slate-200 mx-auto mb-3" />
          <p className="text-slate-500">Aucun support pédagogique disponible pour le moment</p>
        </CardContent>
      </Card>
    );
  }

  const isNew = (s) => lastSeen !== null && (s.uploaded_at || '') > lastSeen;

  return (
    <div className="space-y-4" data-testid="supports-tab-content">
      {data.map(d => (
        <Card key={d.dossier_id} className="border-0 shadow-sm" data-testid={`supports-dossier-${d.dossier_id}`}>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm flex items-center justify-between">
              <span>{d.dossier_intitule || d.formation_titre}</span>
              <Badge variant="outline" className="text-xs">{d.dossier_code}</Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {d.modules.map(m => (
              <div key={m.module_id}>
                <p className="text-xs font-semibold text-slate-600 mb-1.5 flex items-center gap-1.5">
                  <span className="font-mono text-indigo-600">{m.code}</span> {m.titre}
                </p>
                <div className="space-y-1.5">
                  {m.supports.map(s => (
                    <div key={s.id} className="flex items-center gap-2 p-2.5 bg-sky-50 rounded-lg border border-sky-100" data-testid={`candidat-support-${s.id}`}>
                      <FileText className="w-4 h-4 text-sky-600 flex-shrink-0" />
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2">
                          <p className="text-sm font-medium text-slate-800 truncate">{s.filename}</p>
                          {isNew(s) && (
                            <span className="px-1.5 py-0.5 rounded-full bg-red-500 text-white text-[9px] font-bold flex-shrink-0" data-testid={`pill-nouveau-${s.id}`}>
                              Nouveau
                            </span>
                          )}
                        </div>
                        <p className="text-[10px] text-slate-400">{formatTaille(s.taille)}</p>
                      </div>
                      <Button
                        size="sm"
                        variant="outline"
                        className="h-8 text-xs gap-1.5 text-sky-700 border-sky-200 hover:bg-sky-100"
                        onClick={() => downloadSupport(s)}
                        data-testid={`btn-candidat-download-${s.id}`}
                      >
                        <Download className="w-3.5 h-3.5" /> Télécharger
                      </Button>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
